import { type MutationHookOptions, useMutation } from "@apollo/client";
import { CreatePlatformPageMutation } from "../graphql/mutations";

export const useCreatePlatformPageMutation = (
  options?: MutationHookOptions<any, any>
) => {
  return useMutation<any, any>(CreatePlatformPageMutation, options);
};
